export default "__VITE_ASSET__BqoVMuHW__"